import React from 'react'
import { useToken } from '@hub/design-system-base'
import { Select } from '@hub/select'
import { CategoryListProps } from '@scentregroup/shared/types/browse-stores'
import { RetailCategory } from '../stores/types'

export const CategoryList: React.FC<
  React.PropsWithChildren<CategoryListProps>
> = ({ categories, value, placeholder, onChange }) => {
  const iconOffsetMargin = useToken('space', 'spacing-lg')
  return (
    <Select
      value={value}
      placeholder={placeholder || 'Select an item'}
      sx={{
        paddingRight: 'spacing-xl',
        textAlign: 'left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        marginRight: `calc(${iconOffsetMargin} * -1)`,
      }}
      onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
        onChange(e.target.value)
      }
    >
      {categories.map((category: RetailCategory) => (
        <option value={category.title} key={category.id}>
          {category.title}
        </option>
      ))}
    </Select>
  )
}
